module.exports = __webpack_public_path__ + "static/media/loop.19614b8f.svg";